import { HTTP_GET, HTTP_POST, WebApiRequest, HTTP_PUT } from "tools/webservice";
import { qa } from "apis/qualityAssurance";
import { GetCaseInfoResponse, QaTimeCardResponseDetail, QualityAssuranceAgentList } from "interfaces/Mueller.Business.Models";
import { Ref } from "react";

export const getCaseIntegrationFile = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/homeowner/cases/pnx-integration-file/${controlNumber}`,
  successCallback,
  mountedRef,
});
export const getGpsData = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa/${controlNumber}/case-geocode`,
  successCallback,
  mountedRef,
});
export const updateGpsData = (controlNumber, photo, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/qa/${controlNumber}/case-geocode`,
  payload: photo,
  successCallback,
  mountedRef,
});
export const sendCases = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/qa/send/cases`,
  payload,
  successCallback,
  errorCallback,
  mountedRef
});

export const unassignCases = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/qa/unassign/cases`,
  payload,
  successCallback,
  errorCallback,
  mountedRef
});

export const getPaySummary = (internetUserId, payPeriodId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: qa.getPaySummary(internetUserId, payPeriodId),
  successCallback,
  mountedRef,
});
export const updateCalcHeaderSettings = (controlNumber, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/qa/${controlNumber}/calc/settings`,
  payload,
  successCallback,
  errorCallback,
  mountedRef
});
export const moveToTopOfInspectionQueue = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/qa/${controlIdNumber}/inspection-queue/move-case-to-top`,
  successCallback,
  mountedRef,
});
export const moveToTopOfAppraisalQueue = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/qa/${controlIdNumber}/appraisal-queue/move-case-to-top`,
  successCallback,
  mountedRef,
});
export const validateGeoTagForm = (controlNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa/${controlNumber}/validate-geotag-form`,
  successCallback,
  errorCallback,
  mountedRef
});
export const getQaTeamList = (successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qateams/active`,
  successCallback,
  errorCallback,
  mountedRef
});
export const getCasesInQueue = (employeeId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa/employee/${employeeId}/assigned`,
  successCallback,
  mountedRef
});
export const connectE2Value = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/qa/${controlIdNumber}/e2Value`,
  successCallback,
  mountedRef
});
export const getQAPerformance = (internetUserId, payPeriodId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa/${internetUserId}/payperiods/${payPeriodId}/performance`,
  successCallback,
  mountedRef,
});
export const getQADepartmentList = (search: string, successCallback: (list: QualityAssuranceAgentList[]) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa/department-list${(!!search ? `?search=${search}` : "")}`,
  successCallback,
  errorCallback,
  mountedRef,
});
export const getTimeLogSummaryForCurrentUser = (payPeriodId: number, mountedRef: Ref<boolean>, successCallback?: (response: QaTimeCardResponseDetail) => void, errorCallback?: () => void) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa/user/time-log-summary/pay-period/${payPeriodId}`,
  successCallback,
  errorCallback,
  mountedRef,
});
export const getTimeLogSpeedometerDataForCurrentUser = (mountedRef: Ref<boolean>, successCallback?: (response: QaTimeCardResponseDetail) => void, errorCallback?: () => void) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa/user/time-log-summary/speedometer-data`,
  successCallback,
  errorCallback,
  mountedRef,
});
export const getQaCaseInfo = (controlIdNumber: number, mountedRef: Ref<boolean>, successCallback?: (response: GetCaseInfoResponse) => void, errorCallback?: () => void) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa/case-info/${controlIdNumber}`,
  successCallback,
  errorCallback,
  mountedRef,
});